import React from 'react';
import { FormattedMessage } from 'react-intl';
import { WindshieldPlaceholder } from 'src/easyclaim.app.components/common/ImageRepository';
import { getConfiguration } from 'src/easyclaim.app.configuration/configuration';
import { reportError } from 'src/easyclaim.app.libs/reportError';
import styled from 'styled-components';

import { AppState } from '../AppState';
import { EasyClaimDocumentType } from '../easyclaim.api.client.typescript/src/index';
import {
	DetailContainer,
	DetailsContainer,
	SelectImage,
	StyledInfoIcon,
	ExampleModalImage,
} from '../easyclaim.app.components/index';
import { ImageSelectionService } from '../easyclaim.app.services';

import { ScreenComponent } from './ScreenComponent';

interface WindshieldImageState {}

export class WindshieldImage extends ScreenComponent<AppState, WindshieldImageState> {
	constructor(props: AppState) {
		super(props);

		this.state = {};

		this.showWindshieldImageExampleModal = this.showWindshieldImageExampleModal.bind(this);
	}

	async showWindshieldImageExampleModal() {
		const customerName = this.props.easyClaimCase?._configuration?.companyShortName;
		const imageSrcFromConfiguration = getConfiguration('exampleWindshieldImage', customerName);
		const baseUrl = `${process.env.PUBLIC_URL}/images/`;
		const imageSrcSufix = imageSrcFromConfiguration;
		const imageSrc = baseUrl + imageSrcSufix;

		const images: ExampleModalImage[] = [
			{
				src: imageSrc,
			},
		];

		await this.props.showExampleModal(
			images,
			'windshieldExampleModal.headline.first',
			'windshieldExampleModal.button.close',
			'windshield'
		);
	}

	public render() {
		return (
			<>
				<h2 className="windshield-title">
					<FormattedMessage id="windshieldImage.title" />
				</h2>
				<DetailsContainer>
					<DetailContainer>
						<Paragraph>
							<FormattedMessage id="windshieldImage.description" />{' '}
							<StyledInfoIcon
								onClick={() => {
									void this.showWindshieldImageExampleModal().catch((error: unknown) => {
										reportError(error, { context: 'WindshieldImage.asyncAction' });
									});
								}}
							/>
						</Paragraph>
						<SelectImage
							componentId="windshieldImage"
							fileType={EasyClaimDocumentType.WindshieldPicture}
							caseId={this.props.easyClaimCase?.caseId}
							easyClaimService={this.props.easyClaimService}
							currentImage={this.props.windshieldImage}
							title="windshieldImage.headline"
							marginBottom="1rem"
							onChange={(image) => {
								const isImageLoading = ImageSelectionService.isImageLoading(image);

								const newState = Object.assign({}, this.props, {
									windshieldImage: image,
									isImageLoading: isImageLoading,
								});

								void this.props.setAppState(newState);
							}}
							onShowExample={() => {
								void this.showWindshieldImageExampleModal().catch((error: unknown) => {
									reportError(error, {
										context: 'WindshieldImage.showWindshieldImageExampleModal',
									});
								});
							}}
							showUserFeedbackInfo={true}
							placeholder={<WindshieldPlaceholder />}
							configuration={this.props.easyClaimCase!._configuration!}
							inputError={this.props.inputError}
							canOverlayCamera={this.props.easyClaimCase?._configuration?.canShowOverlayOnCamera}
						/>
					</DetailContainer>
				</DetailsContainer>
			</>
		);
	}
}

const Paragraph = styled.p`
	margin-bottom: 1rem;
	hyphens: auto;
	user-select: none;
	cursor: default;
`;
